import type { FFmpeg } from '@ffmpeg/ffmpeg'
import {
  SET_FFMPEG_INSTANCE,
  SET_REAUTH_MODAL_OPTIONS,
} from 'contexts/actions/ui'
import { switchcaseF } from 'helpers/utils'
import type { Payload } from 'types/common'

export type ReauthModalOptions = {
  isReauthModalVisible: boolean
  onComplete: () => void
  onError: (reason?: string) => void
}

export const uiState: {
  ffmpegInstance: null | FFmpeg
  reauthModalOptions: ReauthModalOptions | null
} = {
  ffmpegInstance: null,
  reauthModalOptions: null,
}

const uiReducer = (state: Payload, actionData: { type: string } & Payload) =>
  switchcaseF({
    [SET_FFMPEG_INSTANCE]: () => ({
      ...state,
      ffmpegInstance: actionData.ffmpegInstance,
    }),
    [SET_REAUTH_MODAL_OPTIONS]: () => ({
      ...state,
      reauthModalOptions: actionData.reauthModalOptions,
    }),
  })(() => state)(actionData.type)

export default uiReducer
